import(/* webpackMode: "eager", webpackExports: ["EntryHeader"] */ "/vercel/path0/app/manifiesto/components/entry-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReadingProgress"] */ "/vercel/path0/app/manifiesto/components/reading-progress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HolistikaContent"] */ "/vercel/path0/app/manifiesto/holistika/components/holistika-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileTableOfContents"] */ "/vercel/path0/app/manifiesto/holistika/components/mobile-toc.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableOfContents"] */ "/vercel/path0/app/manifiesto/holistika/components/table-of-contents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteFooter"] */ "/vercel/path0/components/layout/site-footer.tsx");
